// extracted by mini-css-extract-plugin
module.exports = {"pageContainer":"GameServicesPage_pageContainer__2C7tN"};